import { PropTypes } from 'prop-types';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { ToggleButton } from '@ge/components/toggle-button';

export const ToggleButtonMetaField = ({
  defaultValue,
  label,
  metadata,
  name,
  className,
  fieldArray,
  handleOnClick,
  noIcon,
}) => {
  const { control } = useFormContext();

  const { readOnly, required } = metadata;

  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      rules={{
        required,
      }}
      render={({ value, onChange }) => (
        <ToggleButton
          label={label}
          isToggleOn={value}
          handleOnClick={(e) => {
            onChange(!value);
            if (handleOnClick) {
              handleOnClick(e);
            }
          }}
          disabled={readOnly}
          className={className}
          fieldArray={fieldArray}
          noIcon={noIcon}
        />
      )}
    />
  );
};

ToggleButtonMetaField.propTypes = {
  defaultValue: PropTypes.bool,
  label: PropTypes.string,
  metadata: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  fieldArray: PropTypes.instanceOf(Object),
  handleOnClick: PropTypes.func,
  noIcon: PropTypes.bool,
};
ToggleButtonMetaField.defaultProps = {
  defaultValue: false,
  label: '',
  fieldArray: {},
  handleOnClick: () => {},
};
